import { PeopleOutlined } from '@mui/icons-material';
import { ListItem, Tooltip } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';

import { Folder } from '../../Types/folder';
import AutoTruncatingTypographyWithTooltip from '../AutoTruncatingTypographyWithTooltip';
import FolderIcon from './FolderIcon';
import FolderOptionsMenu from './FolderOptionsMenu/FolderOptionsMenu';
import IntellioAdvantageFolderOptionsMenu from './FolderOptionsMenu/IntellioAdvantageFolderOptionsMenu';

const FolderListItem = ({
  folder,
  onFolderCardClick,
}: {
  folder: Folder;
  onFolderCardClick: () => void;
}): JSX.Element => {
  const { folderId: routeFolderId } = useParams<{ folderId?: string }>();

  return (
    <ListItem
      key={folder.id}
      disablePadding
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        height: '36px',
        cursor: 'pointer',
        border: '1px solid transparent',
        ...(folder.id.toString() === routeFolderId
          ? {
              borderLeft: '5px solid #0047FF',
              paddingLeft: '10px',
            }
          : { paddingLeft: '12px' }),
        '&:hover': {
          backgroundColor: '#E8EEF84C',
          borderColor: '#0047FF',
          borderLeft:
            folder.id.toString() === routeFolderId ? '5px solid #0047FF' : '1px solid #0047FF',
          color: '#070154',
        },
      }}
      onClick={(e) => {
        e.stopPropagation();
        onFolderCardClick();
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <FolderIcon
          currentFolder={folder}
          customStyles={{ height: '20px', width: '20px', color: '#50658E' }}
        />
        <AutoTruncatingTypographyWithTooltip
          text={folder.name}
          variant="subtitle2"
          sx={{
            WebkitLineClamp: 1,
            fontSize: '14px',
            width: '100%',
            fontWeight: '400',
            color: '#50658E',
          }}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {folder.contributors.length > 0 && (
          <Tooltip title="Shared Folder">
            <PeopleOutlined sx={{ height: '20px', width: '20px' }} />
          </Tooltip>
        )}
        {folder.project ? (
          <IntellioAdvantageFolderOptionsMenu folder={folder} />
        ) : (
          <FolderOptionsMenu folder={folder} />
        )}
      </div>
    </ListItem>
  );
};

export default FolderListItem;
